import React, {useEffect} from 'react'
import Fade from 'react-reveal/Fade'
import Zoom from 'react-reveal/Zoom'

function Plumbing() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  return (
    <div>
        <div>
          <Zoom>
        <div className="m-auto text-center"><h3 className="text-red-red1 font-extrabold text-3xl pt-10">OUR<br />Plumbing</h3> <hr className="bg-red-red1 h-1 w-28 rounded-md m-auto" /></div>
      </Zoom>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 py-10 gri">
      <Fade bottom>
        <div className="h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./UPVC pipe .jpeg' alt='carrier' className="h-2/3 w-2/3 items-center m-auto"/>
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">UPVC pipe <br />(all sizes)</h3>
      
          </div>
      </Fade>
      <Fade bottom>
        <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./UPVC elbow .jpeg' alt='wood-oli' className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">UPVC elbow <br />(all sizes)</h3>
          </div>
      </Fade>
      <Fade bottom>
        <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./UPVC tee .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">UPVC tee   <br />(all sizes)</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./UPVC socket .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">UPVC socket <br />(all sizes)</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./GI pipe .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">GI pipe <br />(all sizes)</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./GI nipple .png' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">GI nipple <br />(all sizes)</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./GI union .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">GI union <br />(all sizes)</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./GI plag .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">GI plag <br />(all sizes)</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./PVC.jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">PVC<br />(all sizes)</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Toilet seat.jpg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Toilet seat  <br />(all designs)</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Toilet sink.jpg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Toilet sink <br />(all designs)</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Toilet mirror .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Toilet <br />mirror</h3>
          </div>
      </Fade>
      <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Kitchen sink.jpg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Kitchen sink<br />(1hole & 2holes)</h3>
          </div>          
      </Fade>
      </div>
        </div>
    </div>
  )
}

export default Plumbing